import { useRecipe } from '../context'
import { useBasketHook } from '../context/useBasket'

export const useRecipeCalories = (): number | null => {
  const recipe = useRecipe()
  const useBasket = useBasketHook()

  const { numPortions } = useBasket()

  if (!recipe || !numPortions) {
    return null
  }

  const calories = recipe.calories?.[`for${numPortions}`]

  return calories ?? null
}
